import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CoronaVirusBanner from './CoronaVirusBanner';
import VaccineBanner from './VaccineBanner';

export const verifyDomain = (domain) => {
    return domain.endsWith('.com');
};

const SEARCH_TRACKING_PARAM =
    'utm_source=eventbrite&utm_medium=banner&utm_campaign=search';
const HOME_TRACKING_PARAM =
    'utm_source=eventbrite&utm_medium=banner&utm_campaign=home';

const shouldBannerRender = (props) => {
    if (verifyDomain(props.domain)) {
        return true;
    }

    return false;
};

const getCategory = (isSearch, isAuthenticated) => {
    if (isSearch) {
        return 'search';
    }

    if (isAuthenticated) {
        return 'home-feed';
    }

    return 'home';
};

//TODO: After September 27th delete the time based code
const getBanner = (isSearch) => {
    return { Banner: isSearch ? null : VaccineBanner };
};

const USBanner = (props) => {
    const shouldRender = shouldBannerRender(props);

    if (!shouldRender) {
        return <CoronaVirusBanner />;
    } else {
        const category = getCategory(props.isSearch, props.isAuthenticated);
        const trackingParams = props.isSearch
            ? SEARCH_TRACKING_PARAM
            : HOME_TRACKING_PARAM;

        const { Banner, version } = getBanner(props.isSearch);

        if (!Banner) {
            return null;
        }

        return (
            <Banner
                version={version}
                category={category}
                trackingParams={trackingParams}
                handleTracking={props.handleTracking}
            />
        );
    }
};

USBanner.propTypes = {
    isSearch: PropTypes.bool,
    handleTracking: PropTypes.func,
    isAuthenticated: PropTypes.bool,
};

const _mapStateToProps = (state) => ({
    domain: state.app.domain,
    isAuthenticated: state.auth
        ? state.auth.isAuthenticated
        : state.user.isAuthenticated,
});

const _mapDispatchToProps = (dispatch) => ({
    handleTracking: (...args) => dispatch(...args),
});

export default connect(_mapStateToProps, _mapDispatchToProps)(USBanner);
